// bfd_spec_parsing.js

/**
 * @fileoverview This contains a port of the Bioleap residue spec parsing defined in ratoms.elp.
 */

// CONSTANTS
// ratoms regex    ([^|.:# ]+|first|last)
const reResName = /([^|.:# ]+|first|last)/;
// ratoms regex         (-?[0-9*]{1,5})([A-Za-z_]?)
const reSeqGroupBase = /(-?[0-9*]{1,5})([A-Za-z_]?)/; // sequence number and insertion code
// ratoms regex                (\.(SEQGROUPBASE)?([[:alnum:]]?))
const reSeqGroup = new RegExp(`\\.(${reSeqGroupBase.source})?([A-Za-z0-9]?)`); // dot, seqGroupBase, and alt loc
// ratoms regex       (:([_ ]?|[A-Za-z0-9]{0,4}))?(#([0-9]*))?
const reChainModel = /(:([_ ]?|[A-Za-z0-9]{0,4}))?(#([0-9]*))?/;
// ratoms regex            ^(RESNAME)?(SEQGROUP)?(CHAINMODEL)?$
const reSpec = new RegExp(`^(${reResName.source})?(\\.|${reSeqGroup.source})?(${reChainModel.source})?$`);

const specIndices = {
    // TODO: consider using named capturing groups or converting some to non-capturing groups
    wholeMatch: 0, // in reSpec. Ex: VAL.100AB:A#2
    resnameGroup: 1, // in reSpec. Ex: VAL
    resname: 2, // in reResName. Ex: VAL
    seqGroup: 3, // in reSpec. Ex: .100AB
    seqGroupBaseGroup: 4, // in reSeqGroup. Ex: 100A
    seqnum: 5, // in reSeqGroupBase. Ex: 100
    icode: 6, // in reSeqGroupBase. Ex: A
    altloc: 7, // in reSeqGroup. Ex: B
    chainModelGroup: 8, // in reSpec. Ex: :A#2
    chainGroup: 9, // in reChainModel. Ex: :A
    chain: 10, // in reChainModel. Ex: A
    modelGroup: 11, // in reChainModel. Ex: #2
    modelnum: 12, // in reChainModel. Ex: 2
};
export const RESIDUE_SEQ_NUMBER_UNSPECIFIED = -10000000;
export const MODEL_NUMBER_UNSPECIFIED = 0;

// PARSING FUNCTIONS

/** @param {string} stringIn */
export function bfdParseSpec(stringIn) {
    const string = stringIn.replace(/\*/g, '');
    const match = string.match(reSpec);
    if (!match) return null;

    const indices = specIndices;

    return {
        resname: finishResname(match[indices.resname]),
        seqnum: finishSeqnum(match[indices.seqnum]),
        icode: finishIcode(match[indices.icode]),
        altloc: finishAltloc(match[indices.altloc]),
        chain: finishChain(match[indices.chain]),
        modelnum: finishModelnum(match[indices.modelnum]),
    };
}

// RESULT FIELD HELPERS
function finishResname(resname) {
    return resname ? resname.toUpperCase() : '';
}
function finishSeqnum(seqnum) {
    if (typeof seqnum === 'number') return seqnum;
    return seqnum ? Number(seqnum) : RESIDUE_SEQ_NUMBER_UNSPECIFIED;
}
function finishIcode(icode) {
    return icode && icode !== '_' ? icode : '';
}
function finishAltloc(altloc) {
    return altloc || '';
}
/** @param {string?} chain */
function finishChain(chain) {
    if (!chain) return '';
    if (chain[0] === ' ') {
        return chain.replace(/ /, '_');
    }
    return chain;
}
function finishModelnum(modelnum) {
    if (typeof modelnum === 'number') return modelnum;
    return modelnum ? Number(modelnum) : MODEL_NUMBER_UNSPECIFIED;
}
